export const BACKGROUND_LIGHT_COLOR = 'flat-primary' as 'primary';
